/** お問い合わせ項目: カジュアル相談 */
export const CONTACT_MAIN_CASUAL_TYPES = [
    {
        label: 'PROFFITのサービスや導入事例について聞きたい',
        value: 12,
    },
    {
        label: 'コンサルの活用方法について相談したい',
        value: 10,
    },
    {
        label: 'コンサルにかかる費用について情報収集したい',
        value: 13,
    },
    {
        label: '特定のテーマや業界に強いコンサルを知りたい',
        value: 14,
    },
    {
        label: 'コンサルの選定方法について教えてほしい',
        value: 15,
    },
    {
        label: 'その他',
        value: 4,
    },
];
/** お問い合わせ項目: その他のお問い合せ */
export const CONTACT_MAIN_OTHER_TYPES = [
    {
        label: 'サービスに関して案内してほしい',
        value: 16,
    },
    {
        label: '調達部門の利用事例について知りたい',
        value: 17,
    },
    {
        label: '取材やメディア掲載に関して相談したい',
        value: 18,
    },
    {
        label: 'コンサル業界への転職について相談したい',
        value: 19,
    },
    {
        label: 'その他',
        value: 4,
    },
];
